<template>
  <SettingsPageLayout>
    <div class="mb-2 flex justify-end">
      <TButtonSvg label="New" color="white" @click="showTemplateCreate = true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" />
          <circle cx="12" cy="12" r="9" />
          <line x1="9" y1="12" x2="15" y2="12" />
          <line x1="12" y1="9" x2="12" y2="15" />
        </svg>
      </TButtonSvg>
    </div>
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      <Card v-for="template of templates" :key="template.id">
        <div class="h-48 flex flex-col justify-between">
          <div>
            <div class="flex justify-between">
              <div>
                <h3 class="text-lg font-medium leading-6 text-gray-900 mr-2">{{ template.name }}</h3>
              </div>
            </div>
            <p class="mt-1 text-sm text-gray-500">{{ template.subject }}</p>
          </div>
          <div class="flex justify-between">
            <TButton
              label="Delete"
              color="white"
              @click="
                selectedTemplate = template;
                showTemplateDelete = true;
              "
            >
            </TButton>
            <TButton
              label="Edit"
              color="white"
              @click="
                selectedTemplate = template;
                showTemplateEdit = true;
              "
            >
            </TButton>
          </div>
        </div>
      </Card>
    </div>

    <TemplateCreate
      v-if="showTemplateCreate"
      @handleCancelSettings="showTemplateCreate = false"
      @handleSaveSettings="
        getTemplates();
        showTemplateCreate = false;
      "
    />
    <TemplateEdit
      v-if="showTemplateEdit"
      :selectedTemplate="selectedTemplate"
      @handleCancelSettings="showTemplateEdit = false"
      @handleSaveSettings="
        getTemplates();
        showTemplateEdit = false;
      "
    />
    <TemplateDelete
      v-if="showTemplateDelete"
      :selectedTemplateId="selectedTemplate.id"
      @handleTemplateDeleteCancel="showTemplateDelete = false"
      @handleSaveSettings="
        getTemplates();
        showTemplateDelete = false;
      "
    />
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import Card from '../../Card/index.vue';
import TemplateEdit from './TemplateEdit.vue';
import TemplateDelete from './TemplateDelete.vue';
import TemplateCreate from './TemplateCreate.vue';

export default {
  components: {
    SettingsPageLayout,
    Card,
    TemplateEdit,
    TemplateDelete,
    TemplateCreate,
  },
  data() {
    return {
      templates: [],
      showTemplateEdit: false,
      showTemplateDelete: false,
      showTemplateCreate: false,
      selectedTemplate: null,
    };
  },
  mounted() {
    this.getTemplates();
  },
  methods: {
    getTemplates() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/email_templates`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          self.$store.commit('general/hideLoadingSpinner');
          self.templates = data.records;
        });
    },
  },
};
</script>
